import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import { tpOptions, timeGroupOption, menu029options, menuPoPOptions } from '@/options/option'
import {
  getClient,
  getAuthUserInfo,
  getUserMenuPower,
  getProjectInfo,
  getStations,
  getVirtualStations,
  getGfStations,
  getPmcolorRatio,
  getZhGroupByWz,
  getCalGroups,
  getCapStationType
} from '@/api/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    yuzhi: null,
    userInfo: {},
    projectInfo: {},
    userPowers: {},
    initBaseInfo: false,
    token: null,
    common_info: {
    },
    model: 0,
    stations: [],
    station_dict: {},
    vir_stations: [],
    gf_stations: [],
    treeOptions: [],
    pmcolor_ratio: {},
    cur_time: '',
    currMapStyle: 'normal',
    zhGroupInfo: {},

    // 快照方案状态、信息
    loadSnapStatus: false,
    currentSnapInfo: {},

    // 时间
    line_t: 0,
    timeRange: [moment().subtract(1, 'months').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
    chartTypeStore: 'chart_line',
    data_type: 'pm10',
    time_type: 'hour',
    calied_type: 1,
    showChart: true,
    capStationType: [],

    selectLevels: ["国"],
    serverGroups: [],
    pollution_track: 0

  },
  mutations: {
    setServerGroups(state,payload){
      state.serverGroups = payload
    },
    setyuzhi(state, payload) {
      state.yuzhi = payload
    },
    setToken(state, d) {
      state.token = d
    },
    setLoginInfo(state, d) {
      state.userInfo = d.userInfo
      state.projectInfo = d.projectInfo
      state.userPowers = d.userPowers
    },
    setCommon(state, d) {
      state.common_info = d
    },
    setModel(state, d) {
      console.log(d)
      state.model = d
    },
    setInitBaseInfo(state, d) {
      state.initBaseInfo = d
    },
    setStations(state, d) {
      state.stations = d
    },
    setStationDict(state, d) {
      state.station_dict = d
    },
    setVirStations(state, d) {
      state.vir_stations = d
    },
    setGfStations(state, d) {
      state.gf_stations = d
    },
    setPmColorRatio(state, d) {
      state.pmcolor_ratio = d
    },
    setTreeOption(state, d) {
      state.treeOptions = d
    },
    setCurTime(state, d) {
      state.cur_time = d
    },
    setCurrMapStyle(state, d) {
      state.currMapStyle = d
    },
    setZhGroupInfo(state, d) {
      state.zhGroupInfo = d
    },

    setLoadSnapStatus(state, v) {
      state.loadSnapStatus = v;
    },
    setCurrentSnapInfo(state, v) {
      state.currentSnapInfo = v;
    },
    closeSnap(state) {
      state.loadSnapStatus = false;
      state.currentSnapInfo = {};
    },

    setTimeRange(state, v) {
      state.timeRange = v
    },
    setlineT(state, v) {
      state.line_t = v
    },
    setChartType(state, v) {
      state.chartTypeStore = v
    },
    setDataType(state, v) {
      state.data_type = v
    },
    setTimeType(state, v) {
      state.time_type = v
    },
    setCaliedType(state, v) {
      state.calied_type = v
    },
    setShowChart(state, v) {
      state.showChart = v
    },
    setCapStationType(state, v) {
      state.capStationType = v
    },
    setSelectLevels(state, v) {
      state.selectLevels = v
    },
    setPollutionTrack(state, v) {
      state.pollution_track = v
    }
  },
  getters: {
    tpOptionsGetter(state) {
      let d = tpOptions.filter(item => (item.model == 'pro' && state.model == 1) || !item.model)
      if (state.loadSnapStatus) {
        d = d.filter(i => state.currentSnapInfo.typeList.indexOf(i.value) !== -1)
      }
      if (state.model) {
        d = d.concat(menu029options)
      }
      if (state.pollution_track) {
        d = d.concat(menuPoPOptions)
      }
      return d
    },
    lineTStr(state) {
      return moment(state.line_t).format('YYYY-MM-DD HH:mm:ss')
    },
    timeTypeDesc(state) {
      return timeGroupOption.find(x => x.value2 === state.time_type)
    }
  },
  actions: {
    async getUserInfo(context) {
      try {
        if (process.env.DOCK_ENV) {
          await context.dispatch('getUucBaseInfo');
        }
        await context.dispatch('getStations');
        await Promise.all([
          context.dispatch('getZhGroupByWz'),
          context.dispatch('getVirtualStations'),
          context.dispatch('getGfStations'),
          context.dispatch('getPmcolorRatio'),
          context.dispatch('getCapStationType')
        ]);
      } catch (error) {
        console.log(error);
      }
    },
    async getUucBaseInfo(context) {
      try {
        let username = sessionStorage.getItem("userName")
        let clientRes = await getClient(username)
        let userInfoRes = await getAuthUserInfo(clientRes.data.data.proId)
        let menuPowerRes = await getUserMenuPower()
        let projectInfoRes = await getProjectInfo(clientRes.data.data.proId)
        let projectInfoData = projectInfoRes.data.data;
        let regionName =
          (projectInfoData.city || "") + (projectInfoData.county || "");
        let regionId = projectInfoData.countyCode || projectInfoData.cityCode;
        projectInfoData.name = regionName;
        projectInfoData.regionId = regionId;
        return context.commit("setLoginInfo", {userInfo: userInfoRes.data.data, userPowers: menuPowerRes.data.data, projectInfo: projectInfoData});
      } catch (error) {
        console.log(error);
        
      }
    },
    getCapStationType({ state, commit }) {
      console.log(state.projectInfo)
      return getCapStationType(state.projectInfo.regionId).then(x => {
        commit("setCapStationType", x.data.data)
      })
    },
    getZhGroupByWz({ state, commit }) {
      return getZhGroupByWz(state.userInfo.devGroupIds).then(x => {
        commit("setZhGroupInfo", x.data)
      })
    },
    getStations({ state, commit }, group_id) {
      return getStations(group_id || state.userInfo.devGroupIds).then(s => {
        let stations = s.data
        commit('setStations', stations)
        let station_dict = {}
        for (let i of stations) {
          station_dict[i.station_id] = i
        }
        return commit('setStationDict', station_dict)
      })
    },
    async getVirtualStations({state, commit}) {
      let res = await getCalGroups()
      let dyn_groups = res.data.filter(i=>i.enable === 1).map(j => {
        return {name: j.name, station_id: j.dyn_cal_group_id}
      })
      console.log(dyn_groups)
      
      console.log(resAll)
      let res2 = await getVirtualStations(1, state.userInfo.devGroupIds)
      let resAll = await getVirtualStations(1, 32)
      let virStations = res2.data
      let allVirStations = resAll.data
      let otherStations = allVirStations.filter(x=>{
        return !virStations.find(y=>y.group_id === x.group_id)
      })
      console.log(otherStations)
      commit("setServerGroups", otherStations)
      for (let i of virStations){
        let gcj = coordtransform.wgs84togcj02(i.Lng,i.Lat)
        let bd = coordtransform.gcj02tobd09(gcj[0],gcj[1])
        i.Lng = bd[0]
        i.Lat = bd[1]
      }

      let quxian = []
      let jiezhen = []
      let bianjie = []
      let virs = []
      let customs = []
      for (let i of virStations){
        if (i.level == 1 || i.level == 2){
          quxian.push(i)
        }
        if (i.level == 3){
          jiezhen.push(i)
        }
        if (i.level==4){
          bianjie.push(i)
        }
        if (i.type == 2){
          virs.push(i)
        }
        if (i.level ==5){
          customs.push(i)
        }
      }
      var o = [
        {station_id: '-1',name: '区县',children:quxian},
        {station_id: '-2',name: '街镇',children:jiezhen},
        {station_id: '-3',name: '微站',children:state.stations},
      ]
      if (state.model){
        let extra_options = [
          {station_id: '-5',name: '虚拟设备',children:virs},
          {station_id: '-6',name: '自定义组',children:customs},
          {station_id: '-7',name: '动态校准组',children:dyn_groups},
          {station_id: '-4',name: '边界',children:bianjie},
        ]
        o = [...o, ...extra_options]
      }
      commit('setTreeOption', o)
      commit("setInitBaseInfo", true)
      commit('setVirStations', virStations)
    },
    getGfStations({ state, commit }) {
      return getGfStations(state.projectInfo.regionId).then(g => {
        for (let i of g.data.data) {
          let gcj = coordtransform.wgs84togcj02(i.lng, i.lat)
          let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1])
          i.Lng = bd[0]
          i.Lat = bd[1]
        }
        let gf_stations = g.data.data
        commit('setGfStations', gf_stations)
      })
    },
    getPmcolorRatio(context) {
      return getPmcolorRatio().then(s => {
        let pmcolor_ratio = s.data[0]
        context.commit('setPmColorRatio', pmcolor_ratio)
      })
    },
  }
})





// WEBPACK FOOTER //
// ./src/store/index.js